import { h } from "preact";
import { useReducer, useRef } from "preact/hooks";

import router from "../../foundation/router";
import classname from "../../foundation/utils/classname";
import { openLink } from "../../foundation/utils/platform";
import IconMenu from "../Icons/IconMenu";
import Menu from "../v2/Menu";

import "./style.css";

interface State {
    menuOpen: boolean;
    menuOrigin?: {
        x: number;
        y: number;
    };
}

interface Props {
    class?: string;
    menuSeen: boolean;
    onMenuOpen(): void;
}

export default function NewTag({
    menuSeen,
    class: cssClass,
    onMenuOpen
}: Props) {
    const ref = useRef<HTMLButtonElement>(null);
    const [state, setState] = useReducer(
        (oldState: State, newState: State) => ({ ...oldState, ...newState }),
        { menuOpen: false, menuOrigin: undefined }
    );

    function toggleContextMenu() {
        if (ref.current && !state.menuOpen) {
            onMenuOpen();

            const { left, top, height } = ref.current.getBoundingClientRect();

            return setState({
                menuOpen: true,
                menuOrigin: {
                    x: left - 28,
                    y: top + height + 4
                }
            });
        }

        setState({ menuOpen: !state.menuOpen });
    }

    function onClickLearnMore() {
        openLink("https://zpl.io/article/component-versions", { inNewTab: true });
    }

    function onClickShareFeedback() {
        const currentURL = new URL(window.location.href);
        currentURL.searchParams.set("feedback", "componentDetail");
        router.history.replace(currentURL.toString());

        Intercom("showNewMessage", "Component Detail Feedback: ");
    }

    function renderContextMenu() {
        return (
            <Menu.Overlay
                clickOrigin={state.menuOrigin}
                onClose={toggleContextMenu}>
                <Menu.Button
                    content="New feature: Component Version History"
                    subContent="Get a detailed view of a component, along with its version history."
                    disabled>
                    <span class="newTagFeature">Feature: Component Version History</span>
                </Menu.Button>
                <Menu.Divider/>
                <Menu.Button onClick={onClickLearnMore}>
                    Learn more
                </Menu.Button>
                <Menu.Button onClick={onClickShareFeedback}>
                    Share feedback
                </Menu.Button>
            </Menu.Overlay>
        );
    }

    return (
        <button
            ref={ref}
            class={classname("newTag noSelect", cssClass, { focused: state.menuOpen, menuSeen })}
            type="button"
            onClick={toggleContextMenu}>
            <span>New</span><IconMenu width={17} height={17} color={menuSeen ? "var(--gandalf)" : "white"}/>
            {state.menuOpen && renderContextMenu()}
        </button>
    );
}
